module.exports = __webpack_public_path__ + "static/media/hero-thumb-1.01c8c954.svg";